import React from 'react';
import { ResourceRequest } from '../../../hooks/incidentResourceRequestHooks';
import { ResourceRequestMetadata } from '../../types/KanbanTypes';

interface NeedCardProps {
  metadata: ResourceRequestMetadata;
  resourceRequests?: ResourceRequest[];
}

const NeedCard: React.FC<NeedCardProps> = ({ metadata, resourceRequests }) => {
  // Calculate pending quantity
  let pendingQuantity = 0;
  resourceRequests?.forEach((request) => {
    if (request.status !== 'cancelled' && request.items) {
      // Skip if this request is completed (or effectively completed)
      const isCompleted =
        request.status === 'completed' ||
        (request.status === 'awaiting_payment' && request.finance_signature);

      if (!isCompleted) {
        request.items.forEach((item) => {
          if (
            item.kind === metadata.kind &&
            ['pending', 'approved', 'in progress'].includes(
              item.status?.toLowerCase()
            )
          ) {
            pendingQuantity += item.quantity;
          }
        });
      }
    }
  });

  return (
    <>
      <div className="mt-1">
        <strong>Required:</strong> {metadata.totalRequired} |
        <strong> Available:</strong> {metadata.totalAvailable}
      </div>
      <div className="text-danger">
        <strong>Still Need:</strong> {metadata.needed}
      </div>
      {pendingQuantity > 0 && (
        <div className="text-warning mt-1">
          <strong>Being Requested:</strong> {pendingQuantity}
        </div>
      )}
    </>
  );
};

export default NeedCard;
